import { render, staticRenderFns } from "./AboutFeedback.vue?vue&type=template&id=74472dc6&scoped=true&"
import script from "./AboutFeedback.vue?vue&type=script&lang=js&"
export * from "./AboutFeedback.vue?vue&type=script&lang=js&"
import style0 from "./AboutFeedback.vue?vue&type=style&index=0&id=74472dc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74472dc6",
  null
  
)

export default component.exports